'use strict';
import * as $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6 from "./internal-3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.js";
import * as $j_presto$002e$002dGroups$002dView$0024$002dBy$002dCredential$002dAnd$002dDocument$002dType from "./presto.-Groups-View$-By-Credential-And-Document-Type.js";
var $p;
/** @constructor */
function $c_Lpresto_GroupsView$$anon$44() {
}
export { $c_Lpresto_GroupsView$$anon$44 as $c_Lpresto_GroupsView$$anon$44 };
$p = $c_Lpresto_GroupsView$$anon$44.prototype = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$h_O();
$p.constructor = $c_Lpresto_GroupsView$$anon$44;
/** @constructor */
function $h_Lpresto_GroupsView$$anon$44() {
}
export { $h_Lpresto_GroupsView$$anon$44 as $h_Lpresto_GroupsView$$anon$44 };
$h_Lpresto_GroupsView$$anon$44.prototype = $p;
$p.cM3 = (function(x$0) {
  if ((x$0 instanceof $j_presto$002e$002dGroups$002dView$0024$002dBy$002dCredential$002dAnd$002dDocument$002dType.$c_Lpresto_GroupsView$ByCredentialAndDocumentType)) {
    return 0;
  }
  throw new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_s_MatchError(x$0);
});
var $d_Lpresto_GroupsView$$anon$44 = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$TypeData().i($c_Lpresto_GroupsView$$anon$44, "presto.GroupsView$$anon$44", ({
  Kv: 1,
  a: 1,
  e: 1,
  H: 1
}));
export { $d_Lpresto_GroupsView$$anon$44 as $d_Lpresto_GroupsView$$anon$44 };
//# sourceMappingURL=presto.-Groups-View$$anon$44.js.map
